import m from "../../geodata/es2015/sloveniaLow";
window.am4geodata_sloveniaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sloveniaLow.js
// module id = null
// module chunks = 